"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWithId = void 0;
const react_1 = require("react");
const uuid_1 = require("uuid");
// wrap items with an id (by reference)
function useWithId(items) {
    const itemsRef = (0, react_1.useRef)([]);
    itemsRef.current = items.map(item => {
        const found = itemsRef.current.find(ref => ref.item === item);
        return (found === null || found === void 0 ? void 0 : found.id) ? found : { id: (0, uuid_1.v4)(), item };
    });
    return itemsRef.current;
}
exports.useWithId = useWithId;
//# sourceMappingURL=useWithId.js.map